export const PageBlank = () => {
  return (
    <div className="font-garamond bg-zinc-900 flex h-screen w-screen flex-col items-center justify-evenly gap-4 p-8">
      <div></div>
      <p className="text-xl text-stone-400">
        This page intentionally left{' '}
        <span className="text-amber-50">BLACK</span>.
      </p>
      <h1 className="text-amber-50 text-sm">KIBOKURO</h1>
    </div>
  )
}
